import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"

export default () => ({
  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig,
  ),

  init() {
    this.store = Alpine.store("data")

    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
         window.location.reload()
      }
    })

    window.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible" && !this.store.values?.token) {
        window.location.reload()
      }
    })
  },

  handleButton() {
    this.internalTracker.trackClick({ clickName: "Continue Clicked" })
    this.store.goToLogin()
  },
})